import React, { useEffect } from 'react';
import { IconButton, Snackbar } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';

import { selectMessage } from '../../redux/actions/toast';

function toSnackbarMessage(message: any) {
    if (
        typeof message === 'string'
        || typeof message === 'number'
        || typeof message === 'boolean'
        || message === null
        || message === undefined
    ) {
        return message;
    }

    if (typeof message === 'object') {
        if (typeof message.message === 'string') {
            return message.message;
        }
        try {
            return JSON.stringify(message);
        } catch (e) {
            return String(message);
        }
    }

    return String(message);
}

const Toast: React.FC = () => {
    const [open, setOpen] = React.useState(false);

    const message = useSelector(selectMessage());

    useEffect(() => {
        if (message) {
            setOpen(true);
        }
    }, [message]);

    const handleClose = (
        event?: Event | React.SyntheticEvent<any, Event> | React.MouseEvent<HTMLElement>,
        reason?: string
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            message={toSnackbarMessage(message)}
            action={(
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        />
    );
};

export default Toast;
